import React from "react";
import { FaComments } from "react-icons/fa";
import { imgurl } from "../baseurl";
import ChatButton from "./ChatButton";

function CompatibilityCard({ compatibility, loggeduser, user, uid }) {
  const loggedImg = loggeduser?.[0] ? `${imgurl}${loggeduser[0]}` : "";
  const userImg = user?.[0] ? `${user[0]}` : "";
//   const userImg = user?.[0] || "";


// console.log("loggedImg", loggedImg);
// console.log("userImg", userImg);

  // Calculate average score
  const overallScore = Math.round(
    compatibility.reduce((a, b) => a + b.score, 0) / compatibility.length
  );

  return (
    <div
      className="compat-card"
      style={{
        background: "linear-gradient(145deg, #fff, #fff, #fff)",
        padding: "25px",
        borderRadius: "20px",
        color: "white",
        textAlign: "center",
        boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
        position: "relative",
        margin: "50px 0px 0px 0px",
        
      }}
    >
      {/* TOP IMAGES + SCORE */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px", margin: "-50px 0px 0px 0px",
        }}
      >
        {/* User 1 */}
        <img
          src={loggedImg}
          alt="User"
          style={{
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "4px solid #A90D4B",
            margin: "0px -34px 0px 0px",
          }}
        />

        {/* SCORE CIRCLE */}
        <div
          style={{
            width: "80px",
            height: "80px",
            background: "white",
            color: "#A90D4B",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: "24px",
            boxShadow: "0 0 15px rgba(255,255,255,0.6)",zIndex: "99",
          }}
        >
          {overallScore}%
        </div>

        {/* User 2 */}
        <img
          src={userImg}
          alt="User"
          style={{
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "4px solid #A90D4B",
            margin: "0px 0px 0px -34px",
          }}
        />
      </div>

      {/* PROGRESS LIST */}
      <div style={{ marginTop: "25px", textAlign: "left" }}>
        {compatibility.map((c, i) => (
          <div key={i} style={{ marginBottom: "15px" }}>
            <div className="d-flex justify-content-between small">
              <span style={{ color: "#141414ff", fontSize: "14px" }}>
                {c.title}
              </span>
              <strong className="text-dark">{c.score}%</strong>
            </div>

            <div
              style={{
                width: "100%",
                background: "#a5a5a5ad",
                height: "7px",
                borderRadius: "10px",
                marginTop: "4px",
              }}
            >
              <div
                style={{
                  width: `${c.score}%`,
                  background: "#000",
                  height: "7px",
                  borderRadius: "10px",
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>

      {/* START CHAT BUTTON */}
      {/* <button
        style={{
          marginTop: "25px",
          background: "white",
          color: "#ff5a7a",
          padding: "10px 25px",
          fontSize: "16px",
          fontWeight: "bold",
          borderRadius: "25px",
          border: "none",
          display: "inline-flex",
          alignItems: "center",
          gap: "10px",
          boxShadow: "0 4px 15px rgba(255,255,255,0.4)",
          cursor: "pointer",
        }}
      >
        <FaComments /> Start Chat
      </button> */}


      <ChatButton uid={uid} />


    </div>
  );
}

export default CompatibilityCard;
